import { FileNotFoundIcon } from 'assets/icons/HeroIcons/FileNotFoundIcon';
interface FileNotFoundLogoProps {   
    content: React.ReactNode; 
    icon?: React.ReactNode;
    className?: string;
}

export default function FileLogo({ content, icon }: FileNotFoundLogoProps) {
    return (
        <div className={`flex flex-col items-center justify-center h-[calc(100vh-125px)]`}>
            <div className="relative mb-4">
                {icon}
            </div>
            <h3 className="text-xl font-medium text-center">
                {content}
            </h3>
        </div>
    );
}
